import { render, staticRenderFns } from "./ShiftsControl.vue?vue&type=template&id=74ec3dde&"
import script from "./ShiftsControl.vue?vue&type=script&lang=js&"
export * from "./ShiftsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports